// Shared constants/types for the medication upload flow.
//
// Patient list/detail (GET /pharmacy_tech/patient) and upload history
// (GET /pharmacy_tech/{customer_id}/upload) now come from the real API via
// store/pharmacyPatients. What remains here is the client-side file-type
// validation used by the upload modal.

export type MedicationUploadFileType = 'csv' | 'pgp' | 'gpg';

export const ALLOWED_UPLOAD_EXTENSIONS: MedicationUploadFileType[] = [
  'csv',
  'pgp',
  'gpg',
];
